/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable max-lines */

import {
  AddressFields,
  BaseForm,
  ClusterForm,
  DynamicFormFieldKey,
  FormConfig,
  FormFieldConfig,
  FormFieldKey,
  OrganizationBaseForm,
  OrganizationFilterBaseForm,
  OrganizationFilterForm,
  OrganizationFormType1a,
  OrganizationFormType1b,
  OrganizationFormType1c,
  OrganizationFormType1d, OrganizationFormType2,
  OrganizationFormType2abc,
  OrganizationFormType2d, OrganizationFormType3, OrganizationFormType4,
  OrganizationFormType5,
  OrganizationFormType6,
  OrganizationFormType7,
  OrganizationSharedFields1and2, OrganizationSharedFields3and4,
  PersonFilterForm,
  PersonForm,
  PublicFilterForm,
  SelfHelpAddressBaseForm, TopicFilterForm,
  TopicForm, UserForm,
} from 'src/app/@shared/form/form.types';
import {
  EMAIL_VALIDATORS,
  FORM_FIELD_DYNAMIC,
  FORM_FIELD_DYNAMIC_REQUIRED,
  FORM_FIELD_HIDDEN,
  FORM_FIELD_SELECT,
  FORM_FIELD_SELECT_MODAL, FORM_FIELD_SELECT_MODAL_REQUIRED,
  FORM_FIELD_SELECT_OPTIONS_CONTACT_HIDDEN_FIELDS,
  FORM_FIELD_SELECT_OPTIONS_SUB_TYPE,
  FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID,
  FORM_FIELD_SELECT_REQUIRED,
  FORM_FIELD_SIMPLE,
  FORM_FIELD_SIMPLE_REQUIRED,
  PHONE_NUMBER_VALIDATORS,
  URL_VALIDATORS,
} from 'src/app/@shared/form/form-field-config';
import { FORM_FIELD_OPTIONS, getQualificationOptions } from '@data/form-field-options';
import { OrganizationSubTypeForm } from '@common/entities';

// IMPORTANT: for our address fields we set Validators.required later, based on form subtype
const BASE_FORM_ADDRESS: { [key in keyof AddressFields]: FormFieldConfig } = {
  addressStreetAndNumber: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
  },
  addressPostalCode: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    hasCustomErrorText: true,
    validators: [
      ...FORM_FIELD_SIMPLE_REQUIRED.validators,
      {
        key: 'pattern',
        value: /^\d{5}$/u,
      },
    ],
  },
  addressCity: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
  },
  addressFederalState: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.addressFederalState,
    hasTranslation: false,
  },
};

// fields which are part of all 3 main forms (otherAddress, selfHelpAddress, person)
const BASE_FORM: { [key in keyof BaseForm]: FormFieldConfig } = {
  ...BASE_FORM_ADDRESS,
  legacyId: {
    ...FORM_FIELD_SIMPLE,
    readOnly: true,
  },
  type: {
    ...FORM_FIELD_SELECT,
  },
  notes: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  qualifications: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    inputType: 'checkboxOrRadio',
  },
  media: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    inputType: 'checkboxOrRadio',
    options: FORM_FIELD_OPTIONS.media,
    hasTranslation: false,
  },
  // ! currently not used !
  // distributionLists: {
  //  ...FORM_FIELD_DYNAMIC,
  // },
};

// fields which are part of formMainType otherAddress (typ 7) and selfHelpAddress (typ 1-6)
// specific organization form configs can be found in organization module
const ORGANIZATION_BASE_FORM: { [key in keyof OrganizationBaseForm]: FormFieldConfig } = {
  ...BASE_FORM,
  name: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
  },
  phoneContacts: {
    // required validator for dynamic field means we need to provide at least 1 value
    // !! make sure typ3 and typ4 have no office hour inputs !!
    ...FORM_FIELD_DYNAMIC_REQUIRED,
  },
  emailsExtended: {
    ...FORM_FIELD_DYNAMIC_REQUIRED,
    category: 'email',
  },
  websites: {
    ...FORM_FIELD_DYNAMIC,
    hasCustomErrorText: true,
    validators: [...URL_VALIDATORS],
  },
  socialMediaLinks: {
    ...FORM_FIELD_DYNAMIC,
  },
  contactPersons: {
    ...FORM_FIELD_DYNAMIC_REQUIRED,
  },
};

// Public c/o relations have contact values but no type information for resolving a form.
export const ORGANIZATION_CONTACT_FORM_CONFIG: FormConfig = {
  ...BASE_FORM_ADDRESS,
  name: ORGANIZATION_BASE_FORM.name,
  phoneContacts: ORGANIZATION_BASE_FORM.phoneContacts,
  emails: {
    ...FORM_FIELD_DYNAMIC,
  },
  websites: ORGANIZATION_BASE_FORM.websites,
  socialMediaLinks: ORGANIZATION_BASE_FORM.socialMediaLinks,
};

const ORGANIZATION_BASE_FORM_SELF_HELP_ADDRESS: { [key in keyof SelfHelpAddressBaseForm]: FormFieldConfig } = {
  ...ORGANIZATION_BASE_FORM,
  type: {
    ...BASE_FORM.type,
    options: ['selfHelpAddress'],
  },
  subType: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE,
  },
  subTypeForm: {
    ...FORM_FIELD_SELECT,
  },
};

const ORGANIZATION_FORM_SHARED_FIELDS_1_2: { [key in keyof OrganizationSharedFields1and2]: FormFieldConfig } = {
  ...ORGANIZATION_BASE_FORM_SELF_HELP_ADDRESS,
  addressCo: {
    ...FORM_FIELD_SIMPLE,
  },
  status: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.status, // TBD: based on sub type or always the same available values?
    hasTranslation: false,
  },
  isPublished: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    inputType: 'toggle',
  },
  shortName: {
    ...FORM_FIELD_SIMPLE,
  },
  foundingYear: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'number',
  },
};

const FORM_1: { [key in keyof OrganizationSharedFields1and2]: FormFieldConfig } = {
  ...ORGANIZATION_FORM_SHARED_FIELDS_1_2,
  subTypeForm: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressRa,
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type1'),
    hasTranslation: false,
  },
};

const FORM_1A: { [key in keyof OrganizationFormType1a]: FormFieldConfig } = {
  ...FORM_1,
  workingMethod: {
    ...FORM_FIELD_SELECT_REQUIRED,
    inputType: 'checkboxOrRadio',
    options: FORM_FIELD_OPTIONS.workingMethod,
    hasTranslation: false,
  },
  isMainOffice: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    inputType: 'toggle',
    isHidden: true,
  },
  mainOffice: {
    type: 'selectModal',
    hasHint: true,
  },
  branchOffices: {
    type: 'selectModal',
    hasHint: true,
  },
  coverageArea: {
    ...FORM_FIELD_SIMPLE,
  },
  requestsReceivedLastYear: {
    ...FORM_FIELD_SIMPLE,
  },
  numberOfCurrentlyAffiliatedGroups: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'number',
  },
  providedByRed: {
    type: 'selectModal',
  },
  providedByOther: {
    type: 'selectModal',
  },
  isBarrierFree: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
    hasHint: true,
  },
};

const FORM_1B: { [key in keyof OrganizationFormType1b]: FormFieldConfig } = {
  ...FORM_1,
  coverageArea: {
    ...FORM_FIELD_SIMPLE,
  },
  providedByRed: {
    type: 'selectModal',
  },
  providedByOther: {
    type: 'selectModal',
  },
};

const FORM_1C: { [key in keyof OrganizationFormType1c]: FormFieldConfig } = {
  ...FORM_1,
  providesFor: {
    type: 'selectModal',
  },
  providedByRed: {
    type: 'selectModal',
  },
  providedByOther: {
    type: 'selectModal',
  },
};

const FORM_1D: { [key in keyof OrganizationFormType1d]: FormFieldConfig } = {
  ...FORM_1,
  providesFor: {
    ...FORM_FIELD_SELECT_MODAL_REQUIRED,
  },
};

const FORM_2: { [key in keyof OrganizationFormType2]: FormFieldConfig } = {
  ...ORGANIZATION_FORM_SHARED_FIELDS_1_2,
  subTypeForm: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressGa,
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type234'),
    hasTranslation: false,
  },
  hasTransparencyLabel: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
    isHidden: true,
  },
  transparencyPdfId: FORM_FIELD_HIDDEN,
  transparencyPdf: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'file',
    acceptedFileTypes: '.pdf',
  },
};

const FORM_2ABC: { [key in keyof OrganizationFormType2abc]: FormFieldConfig } = {
  ...FORM_2,
  topics: {
    ...FORM_FIELD_SELECT_MODAL_REQUIRED,
    hasHint: true,
  },
  additionalTopics: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  memberCount: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'number',
    hasHint: true,
  },
  headquarters: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.headquarters,
    hasTranslation: false,
  },
  stateLevelSubdivisions: {
    ...FORM_FIELD_SELECT,
    optionsCategory: 'addressFederalState',
    options: FORM_FIELD_OPTIONS.addressFederalState,
    hasTranslation: false,
    hasMultipleValues: true,
    hasHint: true,
  },
};

const FORM_2D: { [key in keyof OrganizationFormType2d]: FormFieldConfig } = {
  ...FORM_2,
  topics: {
    ...FORM_FIELD_SELECT_MODAL_REQUIRED,
    hasHint: true,
  },
  additionalTopics: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
};

const ORGANIZATION_FORM_SHARED_FIELDS_3_4: { [key in keyof OrganizationSharedFields3and4]: FormFieldConfig } = {
  ...ORGANIZATION_BASE_FORM_SELF_HELP_ADDRESS,
  // !!! Overwriting phoneContracts here because it is not required for type3 and type4 !!!
  phoneContacts: {
    ...FORM_FIELD_DYNAMIC,
  },
  // !!! Overwriting contactPersons here because they are not required for type3 and type4 !!!
  contactPersons: {
    ...FORM_FIELD_DYNAMIC,
  },
  // !!! Overwriting address fields here because they are not required for type3 and type4 !!!
  addressStreetAndNumber: {
    ...FORM_FIELD_SIMPLE,
  },
  addressPostalCode: {
    ...FORM_FIELD_SIMPLE,
    validators: [
      {
        key: 'pattern',
        value: /^\d{5}$/u,
      },
    ],
  },
  addressCity: {
    ...FORM_FIELD_SIMPLE,
  },
  addressFederalState: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.addressFederalState,
    hasTranslation: false,
    hasHint: true,
  },
  status: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.status,
    hasTranslation: false,
  },
  isPublished: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    inputType: 'toggle',
  },
  shortName: {
    ...FORM_FIELD_SIMPLE,
  },
  topics: {
    ...FORM_FIELD_SELECT_MODAL_REQUIRED,
    hasHint: true,
  },
  additionalTopics: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  groupStatus: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.groupStatus,
    hasTranslation: false,
  },
  foundingYear: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'number',
  },
  memberCount: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'number',
  },
  coverageArea: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.coverageArea,
    hasTranslation: false,
  },
  targetGroup: {
    ...FORM_FIELD_SELECT_REQUIRED,
    hasMultipleValues: true,
    options: FORM_FIELD_OPTIONS.targetGroup,
    hasTranslation: false,
  },
  description: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
    hasHint: true,
  },
  fileId: FORM_FIELD_HIDDEN,
  file: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'file',
    hasHint: true,
  },
  source: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
    hasHint: true,
  },
  meetingFormat: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.meetingFormat,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  meetingPostalCode: {
    ...FORM_FIELD_SIMPLE,
  },
  meetingLocation: {
    ...FORM_FIELD_SIMPLE,
  },
  toolUsed: {
    ...FORM_FIELD_SIMPLE,
    hasHint: true,
  },
  dataProtectionCompliant: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  language: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.language,
    hasTranslation: false,
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type234'),
    hasTranslation: false,
  },
  localContactPoint: {
    ...FORM_FIELD_SELECT_MODAL,
  },
  contactOrganization: {
    ...FORM_FIELD_SELECT_MODAL,
  },
};

const FORM_3: { [key in keyof OrganizationFormType3]: FormFieldConfig } = {
  ...ORGANIZATION_FORM_SHARED_FIELDS_3_4,
  subTypeForm: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressCommunity,
  },
  searchForms: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressShGroup,
    validators: [
      {
        key: 'required',
      },
    ],
  },
  provider: {
    ...FORM_FIELD_SELECT_MODAL,
    hasHint: true,
  },
};

const FORM_4: { [key in keyof OrganizationFormType4]: FormFieldConfig } = {
  ...ORGANIZATION_FORM_SHARED_FIELDS_3_4,
  subTypeForm: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressShGroup,
  },
  searchForms: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressShGroup,
    validators: [
      {
        key: 'required',
      },
    ],
  },
};

const FORM_5: { [key in keyof OrganizationFormType5]: FormFieldConfig } = {
  ...ORGANIZATION_BASE_FORM_SELF_HELP_ADDRESS,
  addressCo: {
    ...FORM_FIELD_SIMPLE,
  },
  contactViaNakos: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    inputType: 'toggle',
  },
  status: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.status,
    hasTranslation: false,
  },
  isPublished: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    inputType: 'toggle',
  },
  topics: {
    ...FORM_FIELD_SELECT_MODAL_REQUIRED,
  },
  additionalTopics: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  problemExplanation: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  specificIssues: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  affectedPerson: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.affectedPerson,
    hasTranslation: false,
  },
  dateOfBirth: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'date',
    hasHint: true,
  },
  interestedInfos: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.interestedInfos,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  experienceExchangeTopics: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.experienceExchangeTopics,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  foundingInterests: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.foundingInterests,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  contactInterests: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.contactInterests,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type5'),
    hasTranslation: false,
  },
};

const FORM_6: { [key in keyof OrganizationFormType6]?: FormFieldConfig } = {
  ...ORGANIZATION_BASE_FORM_SELF_HELP_ADDRESS,
  name: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
  },
  shortName: {
    ...FORM_FIELD_SIMPLE,
  },
  topics: {
    ...FORM_FIELD_SELECT_MODAL_REQUIRED,
  },
  additionalTopics: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  addressCo: {
    ...FORM_FIELD_SIMPLE,
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type67'),
    hasTranslation: false,
  },
};

const FORM_7: { [key in keyof OrganizationFormType7]: FormFieldConfig } = {
  ...ORGANIZATION_BASE_FORM,
  type: {
    ...BASE_FORM.type,
    options: ['otherAddress'],
  },
  shortName: {
    ...FORM_FIELD_SIMPLE,
  },
  addressCo: {
    ...FORM_FIELD_SIMPLE,
  },
  providesFor: {
    type: 'selectModal',
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type67'),
    hasTranslation: false,
  },
};

// address field validators are set in the person-form.component.ts
const FORM_8: { [key in keyof PersonForm]: FormFieldConfig } = {
  ...BASE_FORM,
  type: {
    ...BASE_FORM.type,
    options: ['person'],
  },
  firstName: {
    ...FORM_FIELD_SIMPLE,
  },
  lastName: {
    ...FORM_FIELD_SIMPLE,
  },
  academicTitle: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.academicTitle,
    hasTranslation: false,
  },
  addressCo: {
    ...FORM_FIELD_SIMPLE,
  },
  addressStreetAndNumber: {
    ...BASE_FORM_ADDRESS.addressStreetAndNumber,
    validators: [
      ...BASE_FORM_ADDRESS.addressStreetAndNumber.validators ?? [],
      {
        key: 'required',
      },
    ],
  },
  addressPostalCode: {
    ...BASE_FORM_ADDRESS.addressPostalCode,
    validators: [
      ...BASE_FORM_ADDRESS.addressPostalCode.validators ?? [],
      {
        key: 'required',
      },
    ],
  },
  addressCity: {
    ...BASE_FORM_ADDRESS.addressCity,
    validators: [
      ...BASE_FORM_ADDRESS.addressCity.validators ?? [],
      {
        key: 'required',
      },
    ],
  },
  addressFederalState: {
    ...BASE_FORM_ADDRESS.addressFederalState,
    validators: [
      ...BASE_FORM_ADDRESS.addressFederalState.validators ?? [],
      {
        key: 'required',
      },
    ],
  },
  emails: {
    ...FORM_FIELD_DYNAMIC,
  },
  phoneNumbers: {
    ...FORM_FIELD_DYNAMIC,
  },
  qualifications: {
    ...BASE_FORM.qualifications,
    options: getQualificationOptions('type8'),
    hasTranslation: false,
  },
};

const FORM_TOPIC: { [key in keyof TopicForm]: FormFieldConfig } = {
  legacyId: {
    ...FORM_FIELD_SIMPLE,
    readOnly: true,
  },
  title: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    category: 'topic',
  },
  englishTitle: {
    ...FORM_FIELD_SIMPLE,
  },
  synonyms: {
    ...FORM_FIELD_DYNAMIC,
  },
  isRareDisease: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    inputType: 'toggle',
  },
  sector: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.sector,
    hasMultipleValues: true,
    hasTranslation: false,
  },
  area: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: FORM_FIELD_OPTIONS.area,
    hasMultipleValues: true,
    hasTranslation: false,
  },
  domain: {
    ...FORM_FIELD_SELECT_REQUIRED,
    options: [], // Loaded from the classification API by FormFieldComponent.
    hasMultipleValues: true,
    hasTranslation: false,
  },
  icd10Codes: {
    ...FORM_FIELD_DYNAMIC,
  },
  icd11Codes: {
    ...FORM_FIELD_DYNAMIC,
  },
  icdArea: {
    ...FORM_FIELD_SELECT,
    options: [], // Loaded from the classification API by FormFieldComponent.
    hasMultipleValues: true,
    hasTranslation: false,
  },
  icdGroup: {
    ...FORM_FIELD_SELECT,
    options: [], // Loaded from the classification API by FormFieldComponent.
    hasMultipleValues: true,
    hasTranslation: false,
  },
  links: {
    ...FORM_FIELD_DYNAMIC,
  },
  notes: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  orphanetTopicId: {
    ...FORM_FIELD_SIMPLE,
  },
  orphanetTopicName: {
    ...FORM_FIELD_SIMPLE,
  },
  orphanetSynonyms: {
    ...FORM_FIELD_DYNAMIC,
  },
};

const FORM_CLUSTER: { [key in keyof ClusterForm]: FormFieldConfig } = {
  title: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
  },
  organizations: {
    type: 'selectModal',
  },
  selfHelpAddresses: {
    type: 'selectModal',
  },
  otherAddresses: {
    type: 'selectModal',
  },
  persons: {
    type: 'selectModal',
  },
  contactPersons: {
    type: 'selectModal',
  },
  topics: {
    type: 'selectModal',
  },
  isSmartCluster: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  includeSelfHelpAddresses: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  includeOtherAddresses: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  includePersons: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  includeContactPersons: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  includeTopics: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'toggle',
  },
  notes: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
};

const FORM_USER: { [key in keyof UserForm]: FormFieldConfig } = {
  firstname: {
    ...FORM_FIELD_SIMPLE,
  },
  lastname: {
    ...FORM_FIELD_SIMPLE,
  },
  alias: {
    ...FORM_FIELD_SIMPLE,
  },
  email: {
    ...FORM_FIELD_SIMPLE_REQUIRED,
    validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...EMAIL_VALIDATORS],
  },
  notes: {
    ...FORM_FIELD_SIMPLE,
    inputType: 'textarea',
  },
  roles: {
    ...FORM_FIELD_SELECT_MODAL,
    hasMultipleValues: true,
  },
};

const FILTER_BASE_FORM: { [key in keyof OrganizationFilterBaseForm]: FormFieldConfig } = {
  addressFederalState: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.addressFederalState,
    hasTranslation: false,
  },
};

const ORGANIZATION_PUBLIC_FILTER_FIELDS: Pick<{ [key in keyof OrganizationFilterForm]: FormFieldConfig },
  'language' | 'stateLevelSubdivisions' | 'targetGroup'> = {
  stateLevelSubdivisions: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    hasTranslation: false,
    options: FORM_FIELD_OPTIONS.addressFederalState,
    optionsCategory: 'addressFederalState',
  },
  targetGroup: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    hasTranslation: false,
    options: FORM_FIELD_OPTIONS.targetGroup,
  },
  language: {
    ...FORM_FIELD_SELECT,
    hasTranslation: false,
    options: FORM_FIELD_OPTIONS.language,
  },
};

// organization filter form
// subType disabled if subtype
export const ORGANIZATION_FILTER_FORM: { [key in keyof OrganizationFilterForm]: FormFieldConfig } = {
  subType: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    // availability/options based on selected type
  },
  subTypeForm: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    // availability/options based on selected subType
  },
  status: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.status,
    hasTranslation: false,
  },
  topics: {
    ...FORM_FIELD_SELECT_MODAL,
    hasMultipleValues: true,
  },
  ...FILTER_BASE_FORM,
  isPublished: {
    ...FORM_FIELD_SELECT,
    options: ['true', 'false'],
    optionsCategory: 'boolean',
  },
  hasTransparencyLabel: {
    ...FORM_FIELD_SELECT,
    options: ['true', 'false'],
    optionsCategory: 'boolean',
  },
  qualifications: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.qualifications,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  media: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.media,
    hasTranslation: false,
    hasMultipleValues: true,
  },
  searchForms: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    options: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID.selfHelpAddressShGroup,
  },
  ...ORGANIZATION_PUBLIC_FILTER_FIELDS,
};

export const PUBLIC_ORGANIZATION_FILTER_FORM: { [key in keyof PublicFilterForm]: FormFieldConfig } = {
  subType: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    optionsCategory: 'publicSubType',
    // availability/options based on selected type
  },
  subTypeForm: {
    ...FORM_FIELD_SELECT,
    hasMultipleValues: true,
    // availability/options based on selected subType
  },
  ...FILTER_BASE_FORM,
  hasTransparencyLabel: {
    ...FORM_FIELD_SELECT,
    options: ['true', 'false'],
    optionsCategory: 'boolean',
  },
  ...ORGANIZATION_PUBLIC_FILTER_FIELDS,
};

export const PERSON_FILTER_FORM: { [key in keyof PersonFilterForm]: FormFieldConfig } = {
  ...FILTER_BASE_FORM,
  qualifications: {
    ...FORM_FIELD_SELECT,
    options: getQualificationOptions('type8'),
    hasTranslation: false,
    hasMultipleValues: true,
  },
  media: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.media,
    hasTranslation: false,
    hasMultipleValues: true,
  },
};

export const TOPIC_FILTER_FORM: { [key in keyof TopicFilterForm]: FormFieldConfig } = {
  isRareDisease: {
    ...FORM_FIELD_SELECT,
    options: ['true', 'false'],
    optionsCategory: 'boolean',
  },
  sector: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.sector,
    hasMultipleValues: true,
    hasTranslation: false,
  },
  area: {
    ...FORM_FIELD_SELECT,
    options: FORM_FIELD_OPTIONS.area,
    hasMultipleValues: true,
    hasTranslation: false,
  },
  domain: {
    ...FORM_FIELD_SELECT,
    options: [], // Loaded from the classification API by FormFieldComponent.
    hasMultipleValues: true,
    hasTranslation: false,
  },
  icd10Codes: {
    ...FORM_FIELD_SIMPLE,
  },
  icd11Codes: {
    ...FORM_FIELD_SIMPLE,
  },
  icdArea: {
    ...FORM_FIELD_SELECT,
    options: [], // Loaded from the classification API by FormFieldComponent.
    hasMultipleValues: true,
    hasTranslation: false,
  },
  icdGroup: {
    ...FORM_FIELD_SELECT,
    options: [], // Loaded from the classification API by FormFieldComponent.
    hasMultipleValues: true,
    hasTranslation: false,
  },
};

// based on NAKOS scheme we have a total of 19 forms
// 1 person form (typ8)
// 1 'otherAddress' form (typ7)
// 16 (!) 'selfHelpAddress' forms (typ1-typ6 including their child forms)
// 1 topic form
// additionally there is a "selfHelpAddress incomplete form" where visible fields are based on selected sub type
// and 1 filter form where visible fields are based on current selected list view

export type FormKey =
  'otherAddress' |
  'person' |
  'selfHelpAddress' |
  'selfHelpAddressBa' |
  'selfHelpAddressOther' |
  OrganizationSubTypeForm |
  'filterDefault' |
  'filterPerson' |
  'filterContactPerson' |
  'filterPublicOrganization' |
  'filterTopic' |
  'filterOrganization' |
  'cluster' |
  'topic' |
  'user';

export const FORM_CONFIG: { [key in FormKey]: FormConfig } = {
  otherAddress: FORM_7,
  selfHelpAddress: ORGANIZATION_BASE_FORM_SELF_HELP_ADDRESS,
  selfHelpAddressRa1a: FORM_1A,
  selfHelpAddressRa1b: FORM_1B,
  selfHelpAddressRa1c: FORM_1C,
  selfHelpAddressRa1d: FORM_1D,
  selfHelpAddressGa2a: FORM_2ABC,
  selfHelpAddressGa2b: FORM_2ABC,
  selfHelpAddressGa2c: FORM_2ABC,
  selfHelpAddressGa2d: FORM_2D,
  selfHelpAddressCommunity3a: FORM_3,
  selfHelpAddressCommunity3b: FORM_3,
  selfHelpAddressCommunity3c: FORM_3,
  selfHelpAddressShGroup4a: FORM_4,
  selfHelpAddressShGroup4b: FORM_4,
  selfHelpAddressShGroup4c: FORM_4,
  selfHelpAddressBa: FORM_5,
  selfHelpAddressOther: FORM_6,
  person: FORM_8,
  topic: FORM_TOPIC,
  cluster: FORM_CLUSTER,
  filterDefault: FILTER_BASE_FORM,
  filterOrganization: ORGANIZATION_FILTER_FORM,
  filterPerson: PERSON_FILTER_FORM,
  filterContactPerson: {
    ...PERSON_FILTER_FORM,
    qualifications: {
      ...PERSON_FILTER_FORM.qualifications,
      options: FORM_FIELD_OPTIONS.qualifications,
    },
  },
  filterPublicOrganization: PUBLIC_ORGANIZATION_FILTER_FORM,
  filterTopic: TOPIC_FILTER_FORM,
  user: FORM_USER,
};

// TODO: if "Verteiler" is present to entity, it should be added here
export const DATA_REVIEW_FORM_HIDDEN_KEYS: FormFieldKey[] = [
  'type',
  'subType',
  'subTypeForm',
  'status',
  'isPublished',
  'notes',
  'foundingYear',
  'workingMethod',
  'mainOffice',
  'branchOffices',
  'qualifications',
  'media',
  'hasTransparencyLabel',
  'transparencyPdf',
  'transparencyPdfId',
  'dataProtectionCompliant',
  'shortName',
  'legacyId',
];

// TODO: provide type
export const DYNAMIC_FORM_FIELD_KEYS: FormFieldKey[] = [
  'phoneContacts',
  'phoneNumbers',
  'emails',
  'emailsExtended',
  'websites',
  'socialMediaLinks',
  'contactPersons',
  'contactPersonsFreeText',
  'topicsFreeText',
  'synonyms',
  'icd10Codes',
  'icd11Codes',
  'links',
  'orphanetSynonyms',
  'useForDataReview',
  'subscribeToNewsletter',
];

// email, website, contactPerson, ...
export const DYNAMIC_FORM_CONFIG: { [k in FormFieldKey]?: { [j in DynamicFormFieldKey]?: FormFieldConfig } } = {
  phoneContacts: {
    number: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'phone_contacts',
      hasCustomErrorText: true,
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...PHONE_NUMBER_VALIDATORS],
    },
    officeHours: {
      ...FORM_FIELD_SIMPLE,
      inputType: 'textarea',
    },
  },
  emails: {
    emails: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'email',
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...EMAIL_VALIDATORS],
    },
  },
  emailsExtended: {
    email: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'email',
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...EMAIL_VALIDATORS],
    },
    useForDataReview: {
      ...FORM_FIELD_SIMPLE,
      inputType: 'toggle',
      hasHint: true,
    },
  },
  phoneNumbers: {
    phoneNumbers: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'phone_numbers',
      hasCustomErrorText: true,
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...PHONE_NUMBER_VALIDATORS],
    },
  },
  websites: {
    websites: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      hasCustomErrorText: true,
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...URL_VALIDATORS],
    },
  },
  socialMediaLinks: {
    socialMediaLinks: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      hasCustomErrorText: true,
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...URL_VALIDATORS],
    },
  },
  contactPersons: {
    id: {
      type: 'simple',
      inputType: 'hidden',
    },
    firstName: {
      ...FORM_FIELD_SIMPLE,
    },
    lastName: {
      ...FORM_FIELD_SIMPLE,
    },
    person: {
      ...FORM_FIELD_SELECT_MODAL_REQUIRED,
    },
    personId: FORM_FIELD_HIDDEN,
    phoneNumber: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'phone_contacts',
      hasCustomErrorText: true,
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...PHONE_NUMBER_VALIDATORS],
    },
    email: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'email',
      inputType: 'text',
      validators: [
        ...FORM_FIELD_SIMPLE_REQUIRED.validators,
        {
          key: 'pattern',
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u,
        },
      ],
    },
    qualifications: {
      ...FORM_FIELD_SELECT,
      options: FORM_FIELD_OPTIONS.qualifications,
      hasTranslation: false,
      hasMultipleValues: true,
    },
    media: {
      ...FORM_FIELD_SELECT,
      options: FORM_FIELD_OPTIONS.media,
      hasTranslation: false,
      hasMultipleValues: true,
    },
    hiddenFields: {
      ...FORM_FIELD_SELECT,
      options: FORM_FIELD_SELECT_OPTIONS_CONTACT_HIDDEN_FIELDS,
      hasMultipleValues: true,
    },
  },
  contactPersonsFreeText: {
    sourceContactPersonId: FORM_FIELD_HIDDEN,
    firstName: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
    },
    lastName: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
    },
    phoneNumber: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'phone_contacts',
      hasCustomErrorText: true,
      validators: [...FORM_FIELD_SIMPLE_REQUIRED.validators, ...PHONE_NUMBER_VALIDATORS],
    },
    email: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      category: 'email',
      inputType: 'text',
      validators: [
        ...FORM_FIELD_SIMPLE_REQUIRED.validators,
        {
          key: 'pattern',
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u,
        },
      ],
    },
    qualifications: {
      ...FORM_FIELD_SELECT,
      options: FORM_FIELD_OPTIONS.qualifications,
      hasTranslation: false,
      hasMultipleValues: true,
    },
    media: {
      ...FORM_FIELD_SELECT,
      options: FORM_FIELD_OPTIONS.media,
      hasTranslation: false,
      hasMultipleValues: true,
    },
    hiddenFields: {
      ...FORM_FIELD_SELECT,
      options: FORM_FIELD_SELECT_OPTIONS_CONTACT_HIDDEN_FIELDS,
      hasMultipleValues: true,
    },
  },
  topicsFreeText: {
    sourceTopicId: FORM_FIELD_HIDDEN,
    topicName: {
      ...FORM_FIELD_SIMPLE_REQUIRED,
      inputType: 'textarea',
    },
    topicSynonyms: {
      ...FORM_FIELD_SIMPLE,
      inputType: 'textarea',
    },
  },
  synonyms: {
    synonyms: {
      ...FORM_FIELD_SIMPLE,
    },
  },
  icd10Codes: {
    icd10Codes: {
      ...FORM_FIELD_SIMPLE,
    },
  },
  icd11Codes: {
    icd11Codes: {
      ...FORM_FIELD_SIMPLE,
    },
  },
  links: {
    links: {
      ...FORM_FIELD_SIMPLE,
    },
  },
  orphanetSynonyms: {
    orphanetSynonym: {
      ...FORM_FIELD_SIMPLE,
    },
    orphanetIcd10Code: {
      ...FORM_FIELD_HIDDEN,
    },
    orphanetId: {
      ...FORM_FIELD_HIDDEN,
    },
  },
};
